// extracted by mini-css-extract-plugin
module.exports = {"Main":"processPage_Main__28yCP","ProcessContainer":"processPage_ProcessContainer__1WAA1"};